export default "__VITE_ASSET__zbxRv3Us__"